"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-global-event" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = ["value"];
const _hoisted_4 = {
    key: 1,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GlobalEvent = (0, vue_1.resolveComponent)("GlobalEvent");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerinput.globalEventNames, (globalEventName) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                key: globalEventName,
                class: "cardBox"
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selected) = $event)),
                    value: globalEventName
                }, null, 8, _hoisted_3), [
                    [vue_1.vModelRadio, _ctx.selected]
                ]),
                (0, vue_1.createVNode)(_component_GlobalEvent, {
                    globalEventName: globalEventName,
                    type: "distant"
                }, null, 8, ["globalEventName"])
            ]));
        }), 128)),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    disabled: _ctx.selected === undefined,
                    type: "submit",
                    onClick: _ctx.saveData,
                    title: "OK"
                }, null, 8, ["disabled", "onClick"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
